export enum NdaTermStatus {
    InAgreement,
    NotInAgreement,
    AwaitingResponse,
    NdaDocumentSent,
    NdaDocumentExecuted,
}

export const NdaTermStatusList = [
    { id: NdaTermStatus.InAgreement, name: 'In Agreement', color: 'green' },
    {
        id: NdaTermStatus.NotInAgreement,
        name: 'Not In Agreement',
        color: 'red',
    },
    {
        id: NdaTermStatus.AwaitingResponse,
        name: 'Awaiting Response',
        color: 'orange',
    },
    {
        id: NdaTermStatus.NdaDocumentSent,
        name: 'Data NDA Sent',
        color: 'orange',
    },
    {
        id: NdaTermStatus.NdaDocumentExecuted,
        name: 'Data NDA Executed',
        color: 'green',
    },
];
